import { render, staticRenderFns } from "./send-a-message.vue?vue&type=template&id=365ee4c4&scoped=true"
import script from "./send-a-message.vue?vue&type=script&lang=js"
export * from "./send-a-message.vue?vue&type=script&lang=js"
import style0 from "./send-a-message.vue?vue&type=style&index=0&id=365ee4c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365ee4c4",
  null
  
)

export default component.exports